export const DEFAULT_LOGO_SIZE = 100;
export const MIN_LOGO_SIZE = 25;
export const MAX_LOGO_SIZE = 150;

// Older settings omit the size. Invalid values should also keep the default.
export const normalizeLogoSize = (value) => {
  if (typeof value !== 'number' && typeof value !== 'string') return DEFAULT_LOGO_SIZE;
  if (typeof value === 'string' && value.trim() === '') return DEFAULT_LOGO_SIZE;
  const size = Number(value);
  return Number.isFinite(size)
    ? Math.min(MAX_LOGO_SIZE, Math.max(MIN_LOGO_SIZE, size))
    : DEFAULT_LOGO_SIZE;
};
